import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-success',
    templateUrl: 'alert-success.component.html',
    styleUrls: [ 'alert-success.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertSuccessComponent implements OnInit {
    @Input() header: string;
    @Input() message: string;
    @Input() messages: string[];

    constructor() {
    }

    public ngOnInit(): void {
        if (this.message) {
            this.messages = this.messages ? [ this.message, ...this.messages ] : [ this.message ];
        }
    }
}
